// React
import * as React from "react";

// Redux
import { connect } from "react-redux";

// Components
import LocationDayChart from "./Charts/LocationDayChart";
import LocationPeopleChart from "./Charts/LocationPeopleChart";

// Components
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import LocationMoneyChart from "./Charts/LocationMoneyChart";
import StatCard from "../components/StatCard";
import ColorManager from "../styles/ColorManager";
import { MethodRequest_e, NetworkManager } from "../managers/NetworkManager";

interface State {
  stats: any;
}

interface Props {
  navigation: any;
}

// Colors
const GREEN_COLOR = "#43a047";
const RED_COLOR = "#d84315";

/**
 * @description Home View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect((state) => state)(
  class Retrospective extends React.Component<Props, State> {
    /**
     * Creates an instance of Home.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {*} props
     * @memberof App
     */
    constructor(props: any) {
      super(props);
      this.state = {
        stats: {
          days: {
            total_futur: 0,
            total_past: 0,
            weekend_futur: 0,
            weekend_past: 0,
            regular_futur: 0,
            regular_past: 0
          },
          person: {
            adult_futur: 0,
            adult_past: 0,
            children_futur: 0,
            children_past: 0,
            total_futur: 0,
            total_past: 0
          },
          month: {
            "1": 0,
            "2": 0,
            "3": 0,
            "4": 0,
            "5": 0,
            "6": 0,
            "7": 0,
            "8": 0,
            "9": 0,
            "10": 0,
            "12": 0
          },
          sum: {
            sum_due: 0,
            sum_received: 0
          }
        }
      };
    }

    async componentWillMount() {
      await NetworkManager.request(
        `bookings/stats/${new Date().getFullYear()}`,
        MethodRequest_e.GET
      ).then((stats: any) => {
        this.setState({
          stats: stats
        });
      });
    }

    componentDidMount() {
      document.title = "Rouges-Terres | Rétrospective";
    }

    /**
     * @description Render the HomeView in the Browser
     * @author Lucas Fridez <lucas@fridez.dev>
     * @returns
     * @memberof App
     */
    public render() {
      const year = new Date().getFullYear();
      return (
        <div>
          <Grid container={true} spacing={24}>
            <Grid item={true} xs={12}>
              <Typography variant="headline" gutterBottom={true}>
                Rétrospective {year}
              </Typography>
            </Grid>
            <Grid item={true} xs={12} lg={6}>
              <LocationDayChart
                data={this.state.stats.days}
                pastColor={GREEN_COLOR}
                futureColor={RED_COLOR}
              />
            </Grid>
            <Grid item={true} xs={12} lg={6}>
              <LocationPeopleChart
                data={this.state.stats.person}
                pastColor={GREEN_COLOR}
                futureColor={RED_COLOR}
              />
            </Grid>
            <Grid item={true} xs={12} lg={6}>
              <LocationMoneyChart
                data={this.state.stats.month}
                pastColor={GREEN_COLOR}
              />
            </Grid>
            <Grid container={true} xs={12} lg={6}>
              <Grid item={true} xs={12}>
                <div style={{ marginTop: 12 }}>
                  <StatCard
                    icon="payments"
                    title="Somme reçue"
                    value={`${this.state.stats.sum.sum_received} CHF`}
                    colorFrom={ColorManager.statCardFrom}
                    colorTo={ColorManager.statCardTo}
                  />
                  <StatCard
                    icon="hourglass_bottom"
                    title="Somme en attente"
                    value={`${this.state.stats.sum.sum_due} CHF`}
                    colorFrom={ColorManager.statCardFrom}
                    colorTo={ColorManager.statCardTo}
                  />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
      );
    }
  }
);



// WEBPACK FOOTER //
// ./src/app/views/Retrospective.tsx